import { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from '../firebase'; // percorso corretto!
import { doc, getDoc } from 'firebase/firestore';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [utente, setUtente] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                const userRef = doc(db, 'utenti', user.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    setUtente({ uid: user.uid, ...userSnap.data() });
                } else {
                    setUtente({ uid: user.uid });
                }
            } else {
                setUtente(null);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    return (
        <AuthContext.Provider value={{ utente, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
